(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Don't hide/reveal/reset the header while a drawer or modal is open —
      // doing so would fight the transform-reset fix in the <style> block
      // above and re-break position:fixed children (menu-drawer, search
      // modal, localization popover) once you've scrolled past the hero.
      if (
        document.body.classList.contains('overflow-hidden-mobile') ||
        document.body.classList.contains('overflow-hidden-tablet') ||
        document.body.classList.contains('overflow-hidden-desktop')
      ) {
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      '#Details-menu-drawer-container a.menu-drawer__menu-item[href]'
    );
    if (!link) return;

    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (!drawerDetails) return;

    // Close the main drawer
    drawerDetails.removeAttribute('open');
    drawerDetails.classList.remove('menu-opening');

    // Also collapse any open submenu <details> so the drawer
    // doesn't reopen mid-submenu next time it's triggered
    drawerDetails.querySelectorAll('details[open]').forEach(function (d) {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
    });

    // The hamburger toggle's aria-expanded="true" drives the CSS rule
    // .header__icon--menu[aria-expanded=true]::before, which paints a
    // full-viewport dim overlay behind the drawer. Left at "true" after
    // we close the drawer manually, that overlay stays visible on the
    // page you land on.
    var summary = drawerDetails.querySelector('summary.header__icon--menu');
    if (summary) summary.setAttribute('aria-expanded', 'false');

    // The header section wrapper (#shopify-section-header) also gets a
    // "menu-open" class while the drawer is open; clear it too.
    var headerSection = document.getElementById('shopify-section-header');
    if (headerSection) headerSection.classList.remove('menu-open');

    // Dawn's <header-drawer> locks scroll via a class named
    // overflow-hidden-{data-breakpoint} (desktop or tablet), applied
    // to <body>. Its own closeMenuDrawer() only runs on a real toggle
    // event, so when we close the drawer programmatically like above,
    // we have to remove that class ourselves or scrolling stays locked.
    var headerDrawer = drawerDetails.closest('header-drawer');
    var breakpoint = headerDrawer ? headerDrawer.dataset.breakpoint : null;

    if (headerDrawer) {
      headerDrawer.classList.remove('menu-opening');
    }

    if (breakpoint) {
      document.body.classList.remove('overflow-hidden-' + breakpoint);
    } else {
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
